// React Third Party Library
import { Form, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Components Library
import DrawerCompany from "../DrawerCompany";

// Redux Library
import * as REDUX_ACTION from "../../../../services/redux/actions";

const { reduxStoreWrapper } = REDUX_UTIL;

const CreateCompanyDrawer = (props) => {
    const { isDrawerOpen, setIsDrawerOpen } = props;
    const [form] = Form.useForm();
    
    const dispatch = useDispatch();
    
    const [messageApi, contextHolder] = message.useMessage();
    
    const user = useSelector(reduxStoreWrapper("user"));
    const employer = useSelector(reduxStoreWrapper("employer.byID"));

    const convertToEpoch = (date) => {
        const dayValue = parseInt(date);
        const currentDate = dayjs();
        const newDate = currentDate.date(dayValue);
        const epochTimestamp = newDate.valueOf();
    
        return epochTimestamp;
      }

    const createEmployer = () => {
        form.validateFields().then((values) => {
        messageApi.open({
            type: "loading",
            content: "Creating company data...",
            duration: 0,
        });
        const emprArr = values?.employers?.map(e => {
            const empr = Object.values(employer).find(option => option.uid === e.value);
            return {uid: empr?.uid, name: empr?.name}
        })

        const { billing_date, billing_period, ...restValues } = values;

        const billingDateNumber = parseInt(billing_date); 
        const updatedValues = {
            ...restValues, 
            billing_date: convertToEpoch(billingDateNumber),
            billing_period: convertToEpoch(billing_period),
            pic : {
                ...values.pic,
                contact : `+60${values.pic.contact}`
            } 
        };
        
        const companyData = {
            ...updatedValues,
            createdBy: user.memid,
            employers : emprArr,
        };

        dispatch(
            REDUX_ACTION.v1_company.create_company_request(companyData, () => {
            messageApi.destroy();
            })
        );
        form.resetFields();
        })
        .catch((err) => {
            message.error("fill the form");
        })
    };

    return (
        <>
            {contextHolder}
            <DrawerCompany
                form={form}
                isOpen={isDrawerOpen}
                setIsOpen={setIsDrawerOpen}
                type="Create"
                handleSave={createEmployer}
            />
        </>
    );
}

export default CreateCompanyDrawer